import React, {useState, useEffect } from 'react';
import { getQueryStringVariable, getQueryStringMap } from '../utils';



export const LandingRequestedOpsContext = React.createContext(null);

function LandingRequestedOpsConf(props) {

	const [landingRequestedOpsContext, setLandingRequestedOpsContext] = useState({
		enabled : false,
		betslipLandingData : null,
		enable : function(){
			this.enabled = true;
			setLandingRequestedOpsContext(function(prev){
	    		return {
	    			...prev,
	    			enabled : true
	    		}
	    	});
		},
		
		disable : function(cleanUrl, reload){
			this.enabled = false;
			setLandingRequestedOpsContext(function(prev){
	    		return {
	    			...prev,
	    			enabled : false
	    		}
	    	});
			if(cleanUrl){
				cleanQueryString(reload);	
			}
		},
		
		setBetslipLandingData : function(betslipLandingData){
			this.betslipLandingData = betslipLandingData;
			setLandingRequestedOpsContext(function(prev){
	    		return {
	    			...prev,
	    			betslipLandingData
	    		}
	    	});
			console.log(betslipLandingData);
		}
		
	});

	useEffect(() => {
		let section = props.section;

		if(!section && typeof props.findSection === 'function'){
			try {
				section = props.findSection(props.pathname);
			}catch(err) {
				console.error(err);
			}
		}

		if(section === 'betslip'){
			const betslipLandingData = {
					selectionsData : getQueryStringVariable('selectionsData'),
					reservationCode : getQueryStringVariable('reservationCode'),
					playDirectly : getQueryStringVariable('playDirectly') || false,
					append: getQueryStringVariable('append') || false,
					vocalAssistant: getQueryStringVariable('vocalAssistant') || false
			};
			if(betslipLandingData.selectionsData && betslipLandingData.reservationCode){
				// malformed querystring. The first one has the highest priority
				betslipLandingData.reservationCode = null;
			}
			landingRequestedOpsContext.setBetslipLandingData(betslipLandingData);
			landingRequestedOpsContext.enable();
		}
	}, [props.section]);
	
	function cleanQueryString(reload){
		// I've to clean the url and landing again in order to avoid a re-do operation
		const map = getQueryStringMap();
		let queryString = ''; 
		// building a new querystring, without the landing op parameters
		for(let k in map){
			if(k !== 'selectionsData' && k !== 'reservationCode' && k !== 'playDirectly'){
				let qPar = k + "=" + map[k];
				queryString =  queryString + (queryString === ''? '' : '&') + qPar;
			}
		}
		let rootPage = new URL(window.location.href).origin;
		if(queryString !== ''){
			rootPage = rootPage + "?" + queryString;
		}
		const reloadTimeout = props.reloadTimeout || 0;
		if(reload){
			setTimeout(() => {
				window.location.href = rootPage;		
			}, reloadTimeout);
				
		}
		else{
			setTimeout(() => {
				// just change url, not reload
				window.history.pushState(null, null, rootPage);	
			}, reloadTimeout);
			
		}
	}
	
	return (
    	<LandingRequestedOpsContext.Provider value={landingRequestedOpsContext}>
			{props.children}
    	</LandingRequestedOpsContext.Provider>
	);	
	
	
	
}

export default LandingRequestedOpsConf;